import { cn } from 'utils/cn';
import { buttonStyle } from 'components/buttons/buttonStyle';
import { Button } from 'components/ui/button';
import { Progress } from 'components/ui/progress';
import React, { useCallback, useState } from 'react';

import { FormattedMessage } from 'react-intl';
import { LimitType } from 'types/invoice-details';
import { t } from 'utils/getTranslations';
import { ModalHeader } from '../ModalHeader';

interface Props {
    onCancel: () => void;
    onConfirm: (value: LimitType) => void;
    titleId: string;
    descriptionId: string;
}

/** The two choices read as cards, not as buttons: a soft edge that fills in while it is pressed. */
const CHOICE = 'border-grey-300 justify-start rounded-lg hover:bg-black/3 new:hover:bg-muted';
const CHOICE_DISABLED = 'bg-black/3 new:bg-muted border-grey-300 justify-start rounded-lg';

const AddNewExpensesConfirmationModal: React.FC<Props> = (props) => {
    const { onCancel, onConfirm, titleId, descriptionId } = props;
    const [isDisabled, setIsDisabled] = useState(false);

    const handleConfirm = useCallback(
        (value: LimitType) => {
            setIsDisabled(true);
            onConfirm(value);
        },
        [onConfirm]
    );

    return (
        <>
            <ModalHeader
                kit
                title={t(titleId)}
                description={<FormattedMessage id={descriptionId} />}
                onCancel={onCancel}
            />
            <div className="new:px-6 new:pt-6 overflow-y-auto p-4 pb-6 max-sm:px-4">
                {/* The new design says this in the header's description. */}
                <p className="text-body1 new:hidden">{<FormattedMessage id={descriptionId} />}</p>
                <div className={cn('new:my-0! mb-3 flex flex-col gap-2', isDisabled ? 'mt-[22px]' : 'mt-9')}>
                    {isDisabled && <Progress value={null} />}
                    <Button
                        {...buttonStyle(
                            { variant: 'outlined', color: 'primary' },
                            isDisabled ? CHOICE_DISABLED : CHOICE
                        )}
                        onClick={() => handleConfirm(LimitType.ALL)}
                        disabled={isDisabled}
                    >
                        <FormattedMessage id="invoices.actions.include-all" />
                    </Button>
                    <Button
                        {...buttonStyle(
                            { variant: 'outlined', color: 'primary' },
                            isDisabled ? CHOICE_DISABLED : CHOICE
                        )}
                        onClick={() => handleConfirm(LimitType.PREV_MONTH)}
                        disabled={isDisabled}
                    >
                        <FormattedMessage id="invoices.actions.include-partly" />
                    </Button>
                </div>
            </div>
        </>
    );
};

export default AddNewExpensesConfirmationModal;
